import React from 'react';
import { SparklesIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
import { Eyebrow } from './Eyebrow';
export function PricingSection() {
  return <section id="angebot" className="scroll-mt-16 bg-brand-alt px-5 py-16 md:py-24" data-id="element-122" data-mp="1ehyvdwx0b4ma">
      <Reveal className="mx-auto max-w-2xl text-center" data-id="element-123" data-mp="1j974erufcnyx">
        <Eyebrow data-id="element-124" data-mp="1jas22qc1cn10">Einführungsangebot</Eyebrow>
        <h2 className="mb-12 mt-5 flex items-center justify-center gap-3 text-3xl font-extrabold text-brand-navy md:text-4xl" data-id="element-125" data-mp="1n9ioa2eyqk9c">
          <SparklesIcon className="h-7 w-7 shrink-0 text-brand-orange" strokeWidth={1.5} aria-hidden="true" data-id="element-126" data-mp="1s82eif0lai7i" />
          Das komplette Musik-Paket
        </h2>
        <div className="overflow-hidden rounded-xl border border-brand-line bg-brand-main shadow-xl" data-id="element-127" data-mp="2271llt5pi5se">
          <div className="h-1.5 w-full bg-brand-orange" aria-hidden="true" data-id="element-128" data-mp="2wjsrxga0a7b" />
          <div className="p-8 md:p-12" data-id="element-129" data-mp="7ul8q9ientek">
            <dl className="space-y-4 text-left" data-id="element-130" data-mp="7vmt54lb9s8y">
              <ValueLine label="10 komplette Bände (Band 1–10)" value="197 €" data-id="element-131" data-mp="1mhpz060ob8eq" />
              <ValueLine label="6 exklusive Boni" value="159 €" data-id="element-132" data-mp="1hpoi26sk8tid" />
              <div className="flex items-baseline justify-between gap-4 border-t border-brand-line pt-5 text-sm font-extrabold uppercase tracking-wide text-brand-navy" data-id="element-133" data-mp="1ho4zuancg8dy">
                <dt data-id="element-134" data-mp="17td0p2e45dh2">Gesamtwert</dt>
                <dd className="shrink-0" data-id="element-135" data-mp="25fis6glhw3yx">356 €</dd>
              </div>
            </dl>
            <p className="mt-10 font-display text-6xl font-extrabold leading-none tracking-tight text-brand-orange md:text-7xl" data-id="element-136" data-mp="25d6ewgqomhs7">
              19 €
            </p>
            <p className="mt-4 text-xs font-semibold text-brand-gray" data-id="element-137" data-mp="1vg1na1e2hu40">
              Einmalige Zahlung <span className="px-1" data-id="element-138" data-mp="1repz80audgxx">·</span> Kein Abo
            </p>
            <div className="mt-8" data-id="element-139" data-mp="k1xzxe1zj47x">
              <CTAButton href="#checkout" className="w-full" data-id="element-140" data-mp="k2z7h8jsl8kw" />
            </div>
            <p className="mt-4 text-xs text-brand-gray" data-id="element-141" data-mp="g0cn1spgapxq">
              Sofort-Download <span className="px-1" data-id="element-142" data-mp="hi193tdbhqfn">·</span> Sichere Bezahlung{' '}
              <span className="px-1" data-id="element-143" data-mp="hijh1n9cdt3e">·</span> 30 Tage Geld-zurück-Garantie
            </p>
          </div>
        </div>
      </Reveal>
    </section>;
}
function ValueLine({
  label,
  value
}: {
  label: string;
  value: string;
}) {
  return <div className="flex items-baseline justify-between gap-4 text-sm" data-id="element-144" data-mp="ciextph1uk9h">
      <dt className="font-medium" data-id="element-145" data-mp="ckrk2etubgsc">{label}</dt>
      <dd className="shrink-0 font-bold text-brand-navy" data-id="element-146" data-mp="3uweb67ibyboj">{value}</dd>
    </div>;
}